import type { LogLevel } from "@beautypie/bp-lib"
import { createLogger, createPinoAdapter } from "@beautypie/bp-lib"
import pino from "pino"

export const Logger = createLogger({
  adapter: createPinoAdapter(pino()),
  level: (process.env.LOG_LEVEL as LogLevel) ?? "warn",
})
